import NoAccessOverlayArticles from './NoAccessOverlayArticles';

export default NoAccessOverlayArticles;
